import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as CustomerAgreementsApi from 'redux/api/internal/CustomerAgreements'

import {
  PatchCustomerAgreementBody,
  PostCustomerAgreementBody
} from 'types/GlobalCustomerAgreement'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

export function tryCreateCustomerAgreement(
  customerId: string,
  body: PostCustomerAgreementBody
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    CustomerAgreementsApi.createCustomerAgreement(customerId, body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.createFailed())
      })
  }
}

export function tryGetCustomerAgreements(customerId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    CustomerAgreementsApi.getCustomerAgreements(customerId)
      .then((response) => {
        dispatch(
          actions.getAllSuccess({ customerId, agreements: response.data.data })
        )
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryUpdatCustomerAgreement(
  customerId: string,
  agreementId: string,
  body: PatchCustomerAgreementBody
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    CustomerAgreementsApi.updateCustomerAgreement(customerId, agreementId, body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.updateFailed())
      })
  }
}

export function tryDeleteCustomerAgreement(
  customerId: string,
  agreementId: string
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    CustomerAgreementsApi.deleteCustomerAgreement(customerId, agreementId)
      .then(() => {
        dispatch(actions.destroySuccess({ customerId, agreementId }))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())
      })
  }
}

export const useCustomerAgreementActions = () => {
  return {
    tryCreateCustomerAgreement: useThunkActions(tryCreateCustomerAgreement),
    tryGetCustomerAgreements: useThunkActions(tryGetCustomerAgreements),
    tryUpdatCustomerAgreement: useThunkActions(tryUpdatCustomerAgreement),
    tryDeleteCustomerAgreement: useThunkActions(tryDeleteCustomerAgreement)
  }
}
